
// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Services ---
import AuthService from '@/services/auth';

@Component
export default class App extends Vue {

  mounted() {
    this.$root.$on('SITE-LOGOUT', () => {
      AuthService.logout();
    });
  }
}
